import { el, mount, unmount } from 'redom';

import ConditionBuilder from '../condition-builder';

class FilterBuilder {

  constructor(options) {

    this.conditionBuilders = [];

    this.fieldSelector = options.fieldSelector;
    this.operatorSelector = options.operatorSelector;
    this.conditions = options.conditions;
    this.onChange = options.onChange;

    this.conditionBuildersContainer = null;

    this.initializeConditionBuilders();

    this.el = el('#filter-builder-main', this.conditionBuildersContainer);

  }

  initializeConditionBuilders() {

    const conditionBuilders = this.conditionBuilders;
    const conditions = this.conditions;
    const conditionsLength = conditions.length;

    for (let index = 0; index < conditionsLength; index++) {

      const condition = conditions[index];
      const conditionBuilder = this.createConditionBuilder(condition, index);

      conditionBuilders.push(conditionBuilder);

    }

    this.conditionBuildersContainer = el('#condition-builders-container', conditionBuilders);

  }

  createConditionBuilder(condition, index) {

    const options = {
      index,
      condition: {
        type: condition.type,
        criteria: condition.criteria
      },
      onChange: this.handleConditionChange.bind(this),
      onRemove: this.handleConditionRemove.bind(this),
      fieldSelector: this.fieldSelector,
      operatorSelector: this.operatorSelector
    };
    const conditionBuilder = new ConditionBuilder(options);

    return conditionBuilder;

  }

  addCondition(condition) {

    const conditionBuilder = this.createConditionBuilder(condition, this.conditions.length);

    this.conditionBuilders.push(conditionBuilder);
    this.handleConditionChange(this.conditions.length, condition);

    mount(this.conditionBuildersContainer, conditionBuilder);

    conditionBuilder.focusInput();

  }

  handleConditionChange(index, condition) {

    this.conditions[index] = condition;

    this.onChange(this.conditions);

  }

  handleConditionRemove(index) {

    this.conditions.splice(index, 1);

    const conditionBuilders = this.conditionBuilders;
    const [conditionBuilder] = conditionBuilders.splice(index, 1);

    unmount(this.conditionBuildersContainer, conditionBuilder);

    const conditionBuildersLength = conditionBuilders.length;

    for (let index = 0; index < conditionBuildersLength; index++) {
      conditionBuilders[index].updateIndex(index);
    }

    this.onChange(this.conditions);

  }

}

export default FilterBuilder;